import React from 'react';
import style from './CollectionsModalList.module.less';
import { Icon, Image } from 'edcom-ui';
import PropTypes from 'prop-types';

export default function CollectionsModalList({
  collections,
  selectCollection,
  showCreate,
}) {
  const collectionsList = !collections
    ? []
    : Object.values(collections).map(c => {
        const img =
          c.thumbnail && c.thumbnail.length ? (
            <Image src={c.thumbnail} className={style.img} alt={c.title} />
          ) : (
            <div className={style.img} />
          );

        const count = Object.keys(c.content).length;
        const items = `${count} ${count === 1 ? 'item' : 'items'}`;

        return (
          <li
            className={style.item}
            key={c.id}
            onClick={() => selectCollection(c.id)}
          >
            {img}
            <div>
              <strong>{c.title}</strong>
              <br />
              <span className={style.count}>{items}</span>
            </div>
          </li>
        );
      });

  return (
    <>
      <h2>Choose collection</h2>
      <ul className={style.list}>
        <li className={style.item} onClick={showCreate}>
          <Icon name="plus-light" className={style.img} isImg={false} />
          <strong>Create new collection</strong>
        </li>
        {collectionsList.length > 0 && (
          <>
            <li className={style.divider} />
            {collectionsList}
          </>
        )}
      </ul>
    </>
  );
}

CollectionsModalList.propTypes = {
  collections: PropTypes.object,
  selectCollection: PropTypes.func,
  showCreate: PropTypes.func,
};
